import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Mission = () => {
  return (
    <Section id="mission">
      <Container>
        <ContentWrapper>
          <MissionPill>Our Mission</MissionPill>

          <MainHeading>
            We Drive <OrangeText>Businesses</OrangeText>
            <br />
            To Close <OrangeText>More Deals</OrangeText>
            <br />
            Book <OrangeText>More Appointments</OrangeText>
            <br />
            Using AI-Powered <OrangeText>Voice Automation.</OrangeText>
          </MainHeading>

          <Description>
            First impressions matter. That’s why our mission is to transform every call into
            <br />
            a seamless, engaging experience with AI-powered voice automation.
          </Description>

          <BookCallButton href="https://cal.com/sonorai/intro" target="_blank" rel="noopener noreferrer">
            Book A Call <ArrowIcon>→</ArrowIcon>
          </BookCallButton>

          <DownArrow>
            <svg width="40" height="70" viewBox="0 0 40 70" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 2V68M20 68L2 50M20 68L38 50" stroke="#00A3FF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </DownArrow>
        </ContentWrapper>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  padding: 120px 20px;
  background-color: black;
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
      radial-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px);
    background-size: 16px 16px;
    opacity: 0.8;
    z-index: 0;
  }

  @media (max-width: 768px) {
    padding: 80px 20px;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const MissionPill = styled.div`
  display: inline-block;
  padding: 8px 20px;
  background-color: rgba(17, 17, 17, 0.9);
  border-radius: 50px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 30px;
`;

const MainHeading = styled.h2`
  font-size: 38px;
  line-height: 1.2;
  color: white;
  font-weight: 400;
  margin-bottom: 30px;
  letter-spacing: -0.5px;
  font-family: var(--font-heading);

  @media (max-width: 768px) {
    font-size: 32px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

const OrangeText = styled.span`
  color: var(--color-ui-orange);
  font-weight: 600;
`;

const Description = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: var(--color-text-gray);
  margin-bottom: 40px;
  font-weight: 400;
`;

const BookCallButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: transparent;
  border: none;
  color: var(--color-ui-orange);
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  padding: 10px 0;
  margin-top: 50px;
  margin-bottom: 50px;
  transition: all 0.3s ease;

  &:hover {
    gap: 12px;
  }
`;

const ArrowIcon = styled.span`
  font-size: 20px;
  transition: transform 0.3s ease;

  ${BookCallButton}:hover & {
    transform: translateX(4px);
  }
`;

const DownArrow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export default Mission;
